export default __webpack_public_path__ + "static/media/DMSans-Medium.b50824fe.woff2";